import { useCallback, useEffect } from 'react'

const usePreventRefresh = isRefreshPrevented => {
  const beforeUnloadCallback = useCallback(
    // eslint-disable-next-line consistent-return
    event => {
      if (isRefreshPrevented) {
        event.preventDefault()
        if (event) {
          // eslint-disable-next-line no-param-reassign
          event.returnValue = ''
        }
        return ''
      }
    },
    [isRefreshPrevented],
  )

  const initBeforeUnload = useCallback(() => {
    window.onbeforeunload = beforeUnloadCallback
  }, [beforeUnloadCallback])

  const clearEventListeners = useCallback(() => {
    window.removeEventListener('onbeforeunload', beforeUnloadCallback)
    window.removeEventListener('onload', initBeforeUnload)
  }, [initBeforeUnload, beforeUnloadCallback])

  window.onload = initBeforeUnload

  useEffect(() => {
    initBeforeUnload()
    return clearEventListeners
  }, [initBeforeUnload, clearEventListeners])
}

export default usePreventRefresh
